import React, { useState } from "react";
import { supabase } from "../supabaseClient";
import { buildAuthRedirect } from "../utils/authRedirect";
import { Link, useNavigate } from "react-router-dom";
import NotificationModal from "../components/NotificationModal";


const RecuperarSenha = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    type: "",
  });

  const navigate = useNavigate();

  const handlePasswordRecovery = async (e) => {
    e.preventDefault();

    setLoading(true);
    setNotification({ show: false, message: "", type: "" });

    const { error: recoveryError } = await supabase.auth.resetPasswordForEmail(
      email,
      {
        redirectTo: buildAuthRedirect("/resetar-senha"),
      },
    );

    if (recoveryError) {
      setNotification({
        show: true,
        message: recoveryError.message,
        type: "error",
      });
    } else {
      setNotification({
        show: true,
        message:
          "Se existir uma conta com este e-mail, enviaremos um link para redefinir sua senha.",
        type: "success",
      });
    }

    setLoading(false);
  };

  const closeNotification = () => {
    setNotification({ ...notification, show: false });
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <img
          src="/assets/logo-transparente-parcial.webp"
          alt="Tesourinhos"
          className="w-28 mx-auto mb-6"
        />

        <h2 className="text-xl font-bold text-slate-800 mb-1 text-center">Recuperar senha</h2>
        <p className="text-sm text-slate-500 mb-6 text-center">
          Digite seu e-mail para receber um link de redefinição de senha.
        </p>

        <form className="flex flex-col gap-3" onSubmit={handlePasswordRecovery} data-cy="recovery-form">
          <input
            data-cy="recovery-email-input"
            placeholder="Digite seu e-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            className="h-11 w-full rounded-lg border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a4e91]/20 focus:border-[#4a4e91] transition"
          />

          <div className="flex flex-col gap-2.5 mt-2">
            <button
              data-cy="recovery-submit-button"
              type="submit"
              className="h-11 w-full rounded-xl bg-rose-400 text-white font-semibold text-sm hover:brightness-105 transition disabled:opacity-70"
              disabled={loading}
            >
              {loading ? "Enviando..." : "Enviar link de recuperação"}
            </button>
            <button
              data-cy="recovery-back-login-button"
              type="button"
              className="h-11 w-full rounded-xl bg-slate-200 text-slate-700 font-semibold text-sm hover:bg-slate-300 transition"
              onClick={() => navigate("/login")}
            >
              Voltar para login
            </button>
          </div>
        </form>

        <p className="mt-5 text-center text-sm text-slate-500">
          Lembrou sua senha?{" "}
          <Link to="/login" data-cy="recovery-login-link" className="text-[#4a4e91] font-semibold">
            Fazer login
          </Link>
        </p>
      </div>

      <NotificationModal
        show={notification.show}
        message={notification.message}
        type={notification.type}
        onClose={closeNotification}
      />
    </div>
  );
};

export default RecuperarSenha;
